import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToppingswizzardComponent } from './toppingswizzard.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ToppingsPageRoutingModule } from '../../toppings/toppings-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from 'src/app/core/pipe.module';
import { PizzaIndicatorModule } from 'src/app/component/pizza-indicator/pizza-indicator.module';



@NgModule({
  declarations: [ToppingswizzardComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ToppingsPageRoutingModule,
    TranslateModule,
    PipeModule,
    PizzaIndicatorModule
  ],
  exports:[
    ToppingswizzardComponent
  ]
})
export class ToppingswizzardModule { }